import React, { useState, useEffect, useCallback, lazy, Suspense } from "react";
import { debounce } from 'lodash';
require("./Navigation.scss");

const DesktopHeader = lazy(() => import('./DesktopHeader'));
const TabletMobileHeader = lazy(() => import('./TabletMobileHeader'));

const Navigation = ({ headernavdata, logo, logopath }) => {
  const getDeviceType = () => {
    const width = window.innerWidth;
    return width < 768 ? 'mobile' : width <= 1024 ? 'tablet' : 'desktop';
  };

  const [device, setDevice] = useState(getDeviceType());

  const updateDevice = useCallback(
    debounce(() => {
      const newDeviceType = getDeviceType();
      if (newDeviceType !== device) setDevice(newDeviceType);
    }, 50),
    [device]
  );

  useEffect(() => {
    window.addEventListener('resize', updateDevice);
    return () => window.removeEventListener('resize', updateDevice);
  }, [updateDevice]);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {device === 'desktop' ? (
        <DesktopHeader headernavdata={headernavdata} logo={logo} logopath={logopath} />
      ) : (
        <TabletMobileHeader headernavdata={headernavdata} logo={logo} logopath={logopath} />
      )}
    </Suspense>
  );
};

export default Navigation;
